/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { CalendarDays, Check, CircleUserRound, X } from "lucide-react";
import { Skeleton } from "primereact/skeleton";
import {
  LEAVE_DAY_TYPES,
  LEAVE_HALF_DAY_TYPES,
} from "../../../../util/constants";
import { CalendarApi } from "@fullcalendar/core"; // Add this import if needed
import { Tooltip } from "primereact/tooltip";
import ShowLeaveComponent from "./ShowLeave";
import ShowHolidayComponent from "./ShowHoliday";

const FullCalendarComponent = ({
  isAddLeaveDialogVisible,
  setIsAddLeaveDialogVisible,
  formValues,
  setFormValues,
  filters,
  leaveTypes,
  setSelectedDates,
  calendarLeaveDataLoading,
  setCalendarLeaveDataLoading,
  calendarLeaveData,
  setCalendarLeaveData,
  setLeaveHistoryID,
  setIsApproveReject,
  setApproveRejectViewType,
  isViewLeaveData,
  setIsViewLeaveData,
}: any) => {
  const [isViewHolidayData, setIsViewHolidayData] = useState<boolean>(false);
  // const [calendarLeaveData, setCalendarLeaveData] = useState<any>([]);

  // useEffect(() => {
  //   fetchCalendarLeaveData(
  //     setCalendarLeaveData,
  //     setCalendarLeaveDataLoading,
  //     filters,
  //     toast
  //   );
  // }, [
  //   filters?.startDate,
  //   filters?.endDate,
  //   filters?.leaveType,
  //   filters?.status,
  //   filters?.user?.userID,
  // ]);

  const [events, setEvents] = useState<any[]>([]);

  // Map calendarLeaveData to FullCalendar events
  useEffect(() => {
    let mappedEvents: any[] = [];
    if (
      calendarLeaveData &&
      calendarLeaveData?.userLeaveData &&
      Array.isArray(calendarLeaveData?.userLeaveData)
    ) {
      mappedEvents = calendarLeaveData.userLeaveData.flatMap((user: any) =>
        (user.userLeave || []).map((leave: any) => {
          const startDate = new Date(
            new Date(leave.startDate * 1000).toISOString()
          );
          const endDate = new Date(
            Date.UTC(
              new Date(
                (leave.endDate || leave.startDate) * 1000
              ).getUTCFullYear(),
              new Date((leave.endDate || leave.startDate) * 1000).getUTCMonth(),
              new Date((leave.endDate || leave.startDate) * 1000).getUTCDate() +
                1
            )
          );
          return {
            id: leave.id.toString(),
            title: "Leave Request",
            start: startDate.toISOString().slice(0, 10),
            end: endDate.toISOString().slice(0, 10),
            extendedProps: {
              leaveHistoryID: leave?.id,
              displayName: user?.displayName,
              lineManagerID: leave?.lineManagerID,
              lineManagerName: leave?.lineManagerName,
              leaveType: leave?.leaveType,
              leaveDayType: leave?.leaveDayType,
              dayPart: leave?.dayPart || "",
              status: leave?.status,
              description: leave?.description,
              hideComment: leave?.hideComment || false,
              managerComments: leave?.manager_comment || "",
            },
          };
        })
      );
    }

    // Always map holidays, even if userLeaveData exists
    let holidayEvents: any[] = [];
    if (
      calendarLeaveData &&
      calendarLeaveData?.holidayData &&
      Array.isArray(calendarLeaveData.holidayData)
    ) {
      holidayEvents = calendarLeaveData.holidayData.map(
        (h: any, idx: number) => {
          const start = new Date(h.startDate * 1000);
          const end = new Date(h.endDate * 1000);
          // FullCalendar's end date is exclusive for all-day events, so add 1 day
          end.setDate(end.getDate() + 1);
          return {
            id: `holiday-${idx}`,
            title: h.name,
            start: start.toISOString().slice(0, 10),
            end: end.toISOString().slice(0, 10),
            allDay: true,
            color: "#FFD700",
            extendedProps: {
              department: h.department,
              status: "HOLIDAY",
              description: h.name,
            },
          };
        }
      );
    }

    setEvents([...mappedEvents, ...holidayEvents]);
  }, [calendarLeaveData?.userLeaveData, calendarLeaveData?.holidayData]);

  // useEffect(() => {
  //   if (
  //     calendarLeaveData &&
  //     calendarLeaveData?.holidayData &&
  //     calendarLeaveData?.holidayData?.length > 0
  //   ) {
  //     const holidayEvents = calendarLeaveData?.holidayData.map(
  //       (holiday: any) => {
  //         const startDate = new Date(
  //           new Date(holiday.startDate * 1000).toISOString()
  //         );
  //         const endDate = new Date(
  //           new Date(holiday.endDate * 1000).toISOString()
  //         );
  //         // For all-day events, FullCalendar's end date is exclusive, so add 1 day
  //         endDate.setDate(endDate.getDate() + 1);

  //         return {
  //           id: `holiday-${holiday.id}`,
  //           title: holiday.name,
  //           start: startDate.toISOString().slice(0, 10), // UTC yyyy-mm-dd
  //           end: endDate.toISOString().slice(0, 10), // UTC yyyy-mm-dd
  //           allDay: true,
  //           extendedProps: {
  //             description: holiday.description || "",
  //             status: "HOLIDAY",
  //           },
  //         };
  //       }
  //     );
  //     setEvents((prevEvents) => [...prevEvents, ...holidayEvents]);
  //   }
  // }, []);

  const [eventType, setEventType] = useState<string>("LEAVE");

  // const [isViewLeaveData, setIsViewLeaveData] = useState<boolean>(false);
  const [leaveData, setLeaveData] = useState<any>({
    leaveHistoryID: null,
    user: null,
    startDate: null,
    endDate: null,
    totalLeaveDays: null,
    leaveType: null,
    leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
    dayPart: LEAVE_HALF_DAY_TYPES.AM,
    description: null,
    lineManagerID: null,
    lineManagerName: null,
    status: null,
    departments: null,
    hideCommet: null,
    managerComments: null,
  });

  const [holidayData, setHolidayData] = useState<any>({
    // holidayID: null,
    name: null,
    startDate: null,
    endDate: null,
    // description: null,
    department: null,
  });

  // Custom event renderer
  function renderEventContent(eventInfo: any) {
    const { event } = eventInfo;
    const { extendedProps } = event;

    // Check if this is a holiday event
    if (extendedProps.status === "HOLIDAY") {
      return (
        <div
          className="tw-bg-[#def8fc] tw-cursor-pointer tw-border-[#00bcd4] tw-border tw-rounded-md tw-p-2 tw-text-black tw-flex tw-flex-col tw-items-center"
          style={{ borderWidth: 2 }}
        >
          <div className="tw-font-bold tw-text-[13px]">Statutory Holiday</div>
          <div className="tw-text-[14px]">{event.title}</div>
          {/* <div className="tw-text-[11px] tw-text-gray-500">
            {extendedProps.department}
          </div> */}
        </div>
      );
    }

    // ...existing code for leave events...
    return (
      <>
        <Tooltip target=".show-desc-calendar" mouseTrack mouseTrackLeft={10} />
        <div
          className={`show-desc-calendar tw-cursor-pointer tw-bg-transparent tw-border tw-px-2 tw-py-1 tw-flex tw-flex-col tw-gap-1 tw-border-solid tw-text-black tw-rounded-md  ${
            extendedProps.status === "SUBMITTED"
              ? "!tw-bg-[#eaf3ff] tw-border-[#007AFF]"
              : extendedProps.status === "APPROVED"
              ? "!tw-bg-[#eaffea] tw-border-[#34C759]"
              : extendedProps.status === "REJECTED"
              ? "!tw-bg-[#ffeaea] tw-border-[#FF3B30]"
              : extendedProps.status === "CANCELLED"
              ? "!tw-bg-[#f2f2f2] tw-border-[#999999]"
              : "!tw-bg-[#fff5e5] tw-border-[#FF9500]"
          }`}
        >
          <div className="tw-flex tw-items-center tw-gap-2 tw-font-medium tw-text-[12px]">
            <CircleUserRound size={12} /> {extendedProps.displayName || "-"}
          </div>
          <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-flex-wrap">
            <div className="tw-flex tw-items-center tw-gap-2 tw-text-[12px]">
              <CalendarDays size={12} /> {extendedProps.leaveType || "-"}
            </div>
            <div className="tw-flex tw-items-center tw-gap-1">
              {/* Approve button: only if status is SUBMITTED (SUBMITTED) */}
              {extendedProps.status === "SUBMITTED" &&
                extendedProps?.lineManagerID?.toString() ===
                  localStorage.userID.toString() && (
                  <>
                    <button
                      type="button"
                      className="tw-bg-green-500 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-size-[25px] tw-cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent parent event click
                        setLeaveHistoryID(extendedProps?.leaveHistoryID);
                        setIsApproveReject(true);
                        setApproveRejectViewType("approve");
                      }}
                    >
                      <Check size={16} color="white" />
                    </button>
                    <button
                      type="button"
                      className="tw-bg-red-500 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-size-[25px] tw-cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent parent event click
                        setApproveRejectViewType("reject");
                        setLeaveHistoryID(extendedProps?.leaveHistoryID);
                        setIsApproveReject(true);
                      }}
                    >
                      <X size={16} color="white" />
                    </button>
                  </>
                )}
            </div>
          </div>
          {extendedProps.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY &&
          extendedProps.dayPart ? (
            <span className="tw-ml-2 tw-text-xs tw-font-semibold tw-text-blue-600">
              {extendedProps.leaveDayType}/{extendedProps.dayPart}
            </span>
          ) : null}
        </div>
      </>
    );
  }

  function handleEventClick(clickInfo: any) {
    const { event } = clickInfo;

    const { extendedProps } = event;

    if (extendedProps?.status === "HOLIDAY") {
      setEventType("HOLIDAY");
      setHolidayData({
        // holidayID: event.id,
        name: event?.title,
        startDate: event.startStr,
        endDate: (() => {
          const end = new Date(event?.endStr);
          end.setDate(end.getDate() - 1);
          return end.toISOString().slice(0, 10);
        })(),
        department: extendedProps?.department || null,
        // description: extendedProps.description || "",
      });
      setIsViewHolidayData(true);
    } else {
      // Calculate total leave days excluding Saturdays and Sundays
      setEventType("LEAVE");

      const start = new Date(event?.startStr);
      const end = new Date(event?.endStr);
      // FullCalendar's end date is exclusive for all-day events, so subtract 1 day
      end.setDate(end.getDate() - 1);

      let totalLeaveDays = 0;
      if (
        extendedProps.leaveDayType &&
        extendedProps.leaveDayType === LEAVE_DAY_TYPES.FULL_DAY
      ) {
        let current = new Date(start);
        while (current <= end) {
          const day = current.getDay();
          if (day !== 0 && day !== 6) {
            totalLeaveDays += 1;
          }
          current.setDate(current.getDate() + 1);
        }
      } else {
        totalLeaveDays = 0.5;
      }

      setLeaveData((prev: any) => ({
        ...prev,
        leaveHistoryID: extendedProps.leaveHistoryID || null,
        user: extendedProps?.displayName || "",
        startDate: event?.startStr,
        totalLeaveDays,
        endDate: event?.endStr,
        leaveType: extendedProps?.leaveType || null,
        leaveDayType: extendedProps.leaveDayType || null,
        dayPart: extendedProps.dayPart || null,
        description: extendedProps?.description || null,
        lineManagerID: extendedProps.lineManagerID || null,
        lineManagerName: extendedProps.lineManagerName || "N/A",
        status: extendedProps.status,
        departments: extendedProps.departments || null,
        managerComments: extendedProps.managerComments || null,
      }));
      setIsViewLeaveData(true);
    }

    // You can add more actions here, like opening a modal with more details
  }

  const handleDateClick = (arg: any) => {
    const epochSeconds = Math.floor(new Date(arg.dateStr).getTime() / 1000);
    setSelectedDates([arg.date, arg.date]);
    setFormValues((prev: any) => ({
      ...prev,
      startDate: epochSeconds,
      endDate: epochSeconds, // Add one day in seconds
      // leaveType: leaveTypes[0]?.id || "", // Default to first leave type if available
      // description: "",
      // status: "SUBMITTED",
      // lineManagerID: localStorage.lineManagerID || "",
    }));
    setIsAddLeaveDialogVisible(true);
  };

  // Add state to track the current view
  const [currentView, setCurrentView] = useState("dayGridMonth");
  const calendarRef = useRef<any>(null);

  // Function to handle view changes
  const handleViewChange = (viewInfo: any) => {
    setCurrentView(viewInfo.view.type);
  };

  // When you reload data (e.g., after approving/rejecting), set the view back to the previous one
  useEffect(() => {
    if (calendarRef.current) {
      const calendarApi: CalendarApi = calendarRef.current.getApi();
      calendarApi.changeView(currentView);
    }
  }, [calendarLeaveDataLoading]); // or any trigger that reloads the calendar

  return (
    <>
      <div className="tw-relative tw-w-full tw-min-h-[600px] tw-bg-white tw-rounded-lg tw-shadow">
        {calendarLeaveDataLoading ? (
          <div className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-justify-center tw-items-center tw-z-50 tw-bg-white/80">
            <Skeleton height="2rem" width="40%" className="tw-mb-4" />
            <div className="tw-grid tw-grid-cols-7 tw-gap-2 tw-w-full">
              {Array.from({ length: 35 }).map((_, i) => (
                <Skeleton key={i} height="4rem" className="tw-mb-2 tw-w-full" />
              ))}
            </div>
          </div>
        ) : (
          <div className="tw-h-full tw-w-full">
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView={currentView}
              headerToolbar={{
                left: "prev,next",
                center: "title",
                right: "dayGridMonth,dayGridWeek",
              }}
              editable={false}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={false}
              events={events}
              eventMaxStack={3}
              eventClick={handleEventClick}
              dateClick={handleDateClick}
              eventContent={renderEventContent}
              views={{
                dayGridWeek: {
                  dayHeaderContent: (args: any) => {
                    const date = args.date;
                    const day = String(date.getDate()).padStart(2, "0");
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const year = date.getFullYear();
                    return `${day}-${month}-${year}`;
                  },
                },
                dayGridMonth: {
                  dayHeaderFormat: { weekday: "short" },
                },
              }}
              datesSet={handleViewChange}
              // eventDidMount={(info) => {
              //   // Set the native title attribute for tooltip
              //   alert(info.event.extendedProps.description)
              //   if (info.event.extendedProps.description) {
              //     info.el.setAttribute("title", info.event.extendedProps.description);
              //   }
              // }}
            />
          </div>
        )}
        {eventType === "LEAVE" ? (
          <>
            <ShowLeaveComponent
              leaveData={leaveData}
              setLeaveData={setLeaveData}
              isViewLeaveData={isViewLeaveData}
              setIsViewLeaveData={setIsViewLeaveData}
              setApproveRejectViewType={setApproveRejectViewType}
              setLeaveHistoryID={setLeaveHistoryID}
              setIsApproveReject={setIsApproveReject}
            />
          </>
        ) : (
          <>
            <ShowHolidayComponent
              holidayData={holidayData}
              setHolidayData={setHolidayData}
              isViewHolidayData={isViewHolidayData}
              setIsViewHolidayData={setIsViewHolidayData}
            />
          </>
        )}
      </div>
    </>
  );
};

export default FullCalendarComponent;
